import React, { FunctionComponent } from 'react'
import { Button } from '@scentregroup/ui'

import Image from '../../../components/image'
import Logo from '../../../components/store-list/logo'
import Store, { CallToAction } from '../store'
import Markdown from '../../../components/markdown'
import RetailerFeature from '../../../components/retailer-feature'

import styles from './index.scss'

interface StoreDetailProps {
  store: Store
  triggerAction: (callsToAction: CallToAction) => void
}

const StoreDetail: FunctionComponent<StoreDetailProps> = ({
  store,
  triggerAction,
}) => (
  <>
    <div className={styles.angle} />
    <div className={styles.StoreDetail}>
      <div>
        <div className={styles.logo}>
          <Logo name={store.title} logo={store.logo} />
        </div>
        <RetailerFeature
          className={styles.retailer}
          title={store.title}
          body={
            <Markdown
              content={store.longDescription}
              dataTestId="store-description"
            />
          }
        />
      </div>
      <div>
        <Image
          className={styles.image}
          imageUrl={store.heroImage.src}
          alt={store.heroImage.alt}
          ratio="square"
          bgSize="cover"
        />
        <div className={styles.actions}>
          {store.callsToAction.map(callToAction => (
            <Button
              key={callToAction.category}
              onClick={() => triggerAction(callToAction)}
            >
              {callToAction.category}
            </Button>
          ))}
        </div>
      </div>
    </div>
  </>
)

export default StoreDetail
